import * as moment from 'moment';

export class DateUtil {

  // return current date in this format 2019_03_30 //
  static getFormattedCurrentDate(date) {
    if (date !== null && date !== undefined && date !== '') {
      const year = date.getFullYear();
      const month = this.fillZero(date.getMonth() + 1);
      const day = this.fillZero(date.getDate());
      date = year + '-' + month + '-' + day;
    } else {
      date = '';
    } return date;
  }

  // return first date of current date in this format 2019_03_01 //
  static getFormatted1stDayOfTheMonth(date) {
    if (date !== null && date !== undefined && date !== '') {
      const year = date.getFullYear();
      const month = this.fillZero(date.getMonth() + 1);
      date = year + '-' + month + '-' + '01';
    } else {
      date = '';
    } return date;
  }

  // return last date of the given date in this format 2019_03_31 //
  static getFormattedLastDayOfTheMonth(date) {
    if (date !== null && date !== undefined && date !== '') {
      const year = date.getFullYear();
      const month = this.fillZero(date.getMonth() + 1);
      const lastDay = new Date(year, month, 0).getDate();
      date = year + '-' + month + '-' + lastDay;
    } else {
      date = '';
    } return date;
  }

  // return date in this format 2019-03-30 //
  static getFormattedDate(date) {
    if (date !== null && date !== undefined && date !== '') {
      date = this.getNewDate(date);
      const year = date.getFullYear();
      const month = this.fillZero(date.getMonth() + 1);
      const day = this.fillZero(date.getDate());
      date = year + '-' + month + '-' + day;
    } else {
      date = '';
    } return date;
  }

  static getYearMonthDate(date) {
    const year = date.getFullYear();
    const month = this.fillZero(date.getMonth() + 1);
    const day = this.fillZero(date.getDate());
    return year + '-' + month + '-' + day;
  }

  static getValidTimeZone(date) {
    if (date !== undefined && date !== null && date !== '') {
      if (date.toString().endsWith('Z')) {
        return this.getNewDate(date.trim().split('Z')[0]);
      } else {
        return date;
      }
    } else {
      return '';
    }
  }

  static getValidTimeZoneT(date) {
    if (date !== null && date !== undefined && date !== '') {
      if (date.includes('T')) {
        date = date.trim().split('T')[0];
      }
    } else {
      date = '';
    }
    return date;
  }

  // return a date string
  static getDateInYYYYMMDD(newDate) {
    if (newDate !== null && newDate !== undefined && newDate !== '') {
      const selectedDate = this.getNewDate(newDate);
      const year = selectedDate.getFullYear();
      const month: any = this.fillZero(selectedDate.getMonth() + 1);
      const date: any = this.fillZero(selectedDate.getDate());
      newDate = year + '-' + month + '-' + date;
    } else {
      newDate = '';
    }
    return newDate;
  }

  static getFormattedDateInMMDDYYYY(date) {
    if (date !== null && date !== undefined && date !== '') {
      const year = date.getFullYear();
      const month = this.fillZero(date.getMonth() + 1);
      const day = this.fillZero(date.getDate());
      date = month + '-' + day + '-' + year;
    } else {
      date = '';
    } return date;
  }

  static fillZero(data) {
    return (data < 10 ? '0' + data : data);
  }

  static setHoursToZero(date: Date) {
    if (date !== null && date !== undefined) {
      date = this.getNewDate(date);
      date.setHours(0, 0, 0);
    }
    return date;
  }

  static getFormattedTime(time) {
    time = time.toString();
    const splittedTime = time.split('.');
    if (splittedTime.length > 1) {
      const hours = this.fillZero(Number(splittedTime[0]));
      const minutes = this.fillZero(Number(splittedTime[1]));
      time = hours + ':' + minutes;
    } else {
      time = this.fillZero(time);
      time = time + ':00';
    }
    return time;
  }

  static getNthDateBefore(date: Date, n: number): Date {
    if (date !== null && date !== undefined) {
      date = this.getNewDate(date);
      date.setDate(date.getDate() - n);
    }
    return date;
  }

  static getNthDateAfter(date, n: number): Date {
    if (date !== null && date !== undefined && date !== '') {
      date = this.getNewDate(date);
      date.setDate(date.getDate() + n);
    }
    return date;
  }

  static getDateInMMDDYYYY(date) {
    if (date !== null && date !== undefined && date !== '') {
      date = this.getValidTimeZone(date);
      date = this.getNewDate(date);
      date = this.fillZero(date.getMonth() + 1) + '/' + this.fillZero(date.getDate()) + '/' + date.getFullYear();
    } else {
      date = '';
    }
    return date;
  }

  static getDateInMMDDYYYYTime(date) {
    if (date !== null && date !== undefined && date !== '') {
      date = this.getValidTimeZone(date);
      date = this.getNewDate(date);
      date = (date.getMonth() + 1) + '/' + date.getDate() + '/' + date.getFullYear() + ' ' +
        this.tConv24(this.fillZero(date.getHours()) + ':' + this.fillZero(date.getMinutes()));
    } else {
      date = '';
    }
    return date;
  }

  static getDateInMMDDYYYYNew(date) {
    if (date !== null && date !== undefined && date !== '') {
      date = this.getNewDate(date);
      const month: any = this.fillZero(date.getMonth() + 1);
      const dateValue: any = this.fillZero(date.getDate());
      date = month + '/' + dateValue + '/' + date.getFullYear();
    } else {
      date = '';
    }
    return date;
  }

  static getDateInMMDDYYYYNullCheck(date) {
    if (date !== null && date !== undefined && date !== '') {
      date = this.getNewDate(date);
      const month: any = this.fillZero(date.getMonth() + 1);
      const dateValue: any = this.fillZero(date.getDate());
      date = month + '/' + dateValue + '/' + date.getFullYear();
    } else {
      date = null;
    }
    return date;
  }

  static getDayOfWeek(date) {
    if (date !== null && date !== undefined && date !== '') {
      const dayOfWeek = this.getNewDate(date).getDay();
      date = isNaN(dayOfWeek) ? null : ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'][dayOfWeek];
    } else {
      date = '';
    }
    return date;
  }

  static getDayOfWeekShort(date) {
    if (date !== null && date !== undefined && date !== '') {
      const dayOfWeek = this.getNewDate(date).getDay();
      date = isNaN(dayOfWeek) ? null : ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'][dayOfWeek];
    } else {
      date = '';
    }
    return date;
  }

  static tConv24(time24) {
    let h;
    let ts = time24;
    const H = +ts.substr(0, 2);
    h = (H % 12) || 12;
    h = (h < 10) ? ('0' + h) : h;  // leading 0 at the left for 1 digit hours
    const ampm = H < 12 ? ' AM' : ' PM';
    ts = h + ts.substr(2, 3) + ampm;
    return ts;
  }

  static getNextWeekSat(date) {
    return date !== null && date !== undefined && date !== '' ?
      this.getNewDate((date.getDate() + 7) - (date.getDay() - 1) + 5) :
      '';
  }

  static getPreviousWeekSat(date) {
    return date !== null && date !== undefined && date !== '' ?
      this.getNewDate(date.setDate((date.getDate() - 14) - (date.getDay() - 1) + 6)) :
      '';
  }

  static getMomentDate(date) {
    if (date !== null && date !== undefined && date !== '') {
      date = moment(date).format('MMM DD, YYYY');
    } else {
      date = '';
    }
    return date;
  }

  static getMomentDateMMDDYYYY(date) {
    return date !== null && date !== undefined && date !== '' ?
      moment(date).format('MM/DD/YYYY') :
      '';
  }

  static getFullDate(date) {
    return moment(DateUtil.getNewDate(date)).format('MMM DD, YYYY hh:mm:ss a');
  }

  static getCurrentDateFormatted(date) {
    let formattedDate = '';
    if (date !== null && date !== undefined && date !== '') {
      const year = date.getFullYear();
      const month = this.fillZero(date.getMonth() + 1);
      const day = this.fillZero(date.getDate());
      formattedDate = year + '-' + month + '-' + day;
    }
    return formattedDate;
  }
  
  static getDetailledDate(date) {
    return moment(DateUtil.getNewDate(date)).format('MMM DD, YYYY hh:mm a');
  }

  static getDateInShortForm(startDate, endDate) {
    const startMonth = moment(startDate).format('MMM DD');
    const endMonth = moment(endDate).format('MMM DD');
    const year = startDate.getFullYear();
    return `${startMonth} to ${endMonth}, ${year}`;
  }

  static getMonthInShortForm(startDate, endDate) {
    const startMonth = moment(startDate).format('MMM');
    const endMonth = moment(endDate).format('MMM');
    const year = DateUtil.getNewDate(startDate).getFullYear();
    return `${startMonth} to ${endMonth}, ${year}`;
  }

  static getRandomNumber() {
    return moment(new Date()).format('YYYYMMDDHHmmssSSS');
  }

  static getFullTime(date) {
    return moment(date).format('hh:MM:ss a');
  }

  static getDiffBetween2days(date1, date2) {
    const Difference_In_Time = date2.getTime() - date1.getTime();
    return Math.round(Difference_In_Time / (1000 * 3600 * 24));
  }

  static getNewDate(date) {
    if (date !== null && date !== undefined && date !== '') {
      date = new Date(date);
    } else {
      date = '';
    }
    return date;
  }

  static getDayStart(date) {
    return this.getNewDate(this.getNewDate(date).setHours(0, 0, 0));
  }

  static getDayEnd(date) {
    return this.getNewDate(this.getNewDate(date).setHours(23, 59, 0));
  }

  // get date of ith next day
  static getIthDay(date, i): string {
    date = DateUtil.getNewDate(date);
    date.setDate(date.getDate() + i);
    return date;
  }
}



// WEBPACK FOOTER //
// ./src/app/util/dateUtil.ts